"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAcceptLegalDocumentsDto = instanceOfAcceptLegalDocumentsDto;
exports.AcceptLegalDocumentsDtoFromJSON = AcceptLegalDocumentsDtoFromJSON;
exports.AcceptLegalDocumentsDtoFromJSONTyped = AcceptLegalDocumentsDtoFromJSONTyped;
exports.AcceptLegalDocumentsDtoToJSON = AcceptLegalDocumentsDtoToJSON;
exports.AcceptLegalDocumentsDtoToJSONTyped = AcceptLegalDocumentsDtoToJSONTyped;
var LegalAcceptanceItemDto_1 = require("./LegalAcceptanceItemDto");
/**
 * Check if a given object implements the AcceptLegalDocumentsDto interface.
 */
function instanceOfAcceptLegalDocumentsDto(value) {
    if (!('acceptances' in value) || value['acceptances'] === undefined)
        return false;
    return true;
}
function AcceptLegalDocumentsDtoFromJSON(json) {
    return AcceptLegalDocumentsDtoFromJSONTyped(json, false);
}
function AcceptLegalDocumentsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'acceptances': (json['acceptances'].map(LegalAcceptanceItemDto_1.LegalAcceptanceItemDtoFromJSON)),
    };
}
function AcceptLegalDocumentsDtoToJSON(json) {
    return AcceptLegalDocumentsDtoToJSONTyped(json, false);
}
function AcceptLegalDocumentsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'acceptances': (value['acceptances'].map(LegalAcceptanceItemDto_1.LegalAcceptanceItemDtoToJSON)),
    };
}
